import useMarket from 'stores/useMarket';

export function useDocuments() {
    const market = useMarket((state) => state.market);
    const path = `/documents/${market}`;

    const integrityPolicyConsultantCustomerHref = `${path}/integritetspolicy-mellan-konsult-och-slutkund-${market}.pdf`;
    const termsAndConditionsHref = `${path}/anvandarvillkor-mymk-${market}.pdf`;

    return {
        integrityPolicyConsultantCustomerHref,
        termsAndConditionsHref,
    };
}
